import utils from '../../core/utility/utils'
import {
  CORE_LOAD_SETTING_INFO_REQUEST,
  CORE_LOAD_SETTING_INFO_SUCCESS,

  CORE_CHECK_AD_REQUEST,
  CORE_CHECK_AD_SUCCESS,

  CORE_LOAD_TIMEZOZE_REQUEST,
  CORE_LOAD_TIMEZOZE_SUCCESS,

  CORE_CHECK_TMS_REQUEST,
  CORE_CHECK_TMS_SUCCESS,
  CORE_CHECK_TMS_FAILURE,

  CORE_CHECK_CMR_REQUEST,
  CORE_CHECK_CMR_SUCCESS,
  CORE_CHECK_CMR_FAILURE,

  CORE_CHECK_BOT_REQUEST,
  CORE_CHECK_BOT_SUCCESS,
  CORE_CHECK_BOT_FAILURE,

  CORE_LOAD_INTEGRATION_DATA_REQUEST,
  CORE_LOAD_INTEGRATION_DATA_SUCCESS,
  CORE_LOAD_INTEGRATION_DATA_FAILURE,
} from '../../types'

// const initialState = []

export default {
  setting: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_SETTING_INFO_REQUEST:
        return state
      case CORE_LOAD_SETTING_INFO_SUCCESS:
        let setting = {}
        // return action.payload
        if (!!action.payload) {
          let payload = action.payload
          setting = {
            ...payload
          }
          if (!!payload.activeDirectoryAdminPassword) {
            setting.activeDirectoryAdminPassword = utils.decode(payload.activeDirectoryAdminPassword)
          }
          if (!!payload.cmr_password) {
            setting.cmr_password = utils.decode(payload.cmr_password)
          }
          if (!!payload.tms_password) {
            setting.tms_password = utils.decode(payload.tms_password)
          }
          if (!!payload.ewsPassword) {
            setting.ewsPassword = utils.decode(payload.ewsPassword)
          }
        }
        return setting
      default:
        return state
    }
  },
  AD: (state = {}, action) => {
    switch (action.type) {
      case CORE_CHECK_AD_REQUEST:
        return {}
      case CORE_CHECK_AD_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  TMS: (state = {}, action) => {
    switch (action.type) {
      case CORE_CHECK_TMS_REQUEST:
        return 'request'
      case CORE_CHECK_TMS_SUCCESS:
        if (action)
          if (typeof action.payload === 'boolean') return action.payload
          else {
            if (action.payload.toLowerCase() === 'true') return true
            else return false
          }
        else return false
      case CORE_CHECK_TMS_FAILURE:
        return false
      default:
        return state
    }
  },
  BOT: (state = {}, action) => {
    switch (action.type) {
      case CORE_CHECK_BOT_REQUEST:
        return 'request'
      case CORE_CHECK_BOT_SUCCESS:
        if (action)
          if (typeof action.payload === 'boolean') return action.payload
          else {
            if (action.payload.toLowerCase() === 'true') return true
            else return false
          }
        else return false
      case CORE_CHECK_BOT_FAILURE:
        return false
      default:
        return state
    }
  },
  CMR: (state = {}, action) => {
    switch (action.type) {
      case CORE_CHECK_CMR_REQUEST:
        return 'request'
      case CORE_CHECK_CMR_SUCCESS:
        if (action)
          if (typeof action.payload === 'boolean') return action.payload
          else {
            if (action.payload.toLowerCase() === 'true') return true
            else return false
          }
        else return false
      case CORE_CHECK_CMR_FAILURE:
        return false
      default:
        return state
    }
  },
  timezone: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_TIMEZOZE_REQUEST:
        return []
      case CORE_LOAD_TIMEZOZE_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  integrationData: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_INTEGRATION_DATA_REQUEST:
        return null
      case CORE_LOAD_INTEGRATION_DATA_SUCCESS:
        return action.payload
      case CORE_LOAD_INTEGRATION_DATA_FAILURE:
        return null
      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/setting/reducer.js